import { reactive } from 'vue';

// Module-level set so any component or helper can share state
const newlyAssignedIds = reactive(new Set());

export const markNewlyAssigned = id => newlyAssignedIds.add(id);
export const clearNewlyAssigned = id => newlyAssignedIds.delete(id);

export function useNewlyAssigned() {
  return { newlyAssignedIds, markNewlyAssigned, clearNewlyAssigned };
}
